// ludoPrize.js

export const LUDO_TAX_RATE = 10;

export const calculateLudoWinning = (winningPrize) => {
    const grossWinning = Number(winningPrize || 0);

    const taxAmount =
        Math.round(
            (grossWinning * LUDO_TAX_RATE / 100) * 100
        ) / 100;

    const netWinning =
        Math.round(
            (grossWinning - taxAmount) * 100
        ) / 100;

    return {
        grossWinning,
        taxAmount,
        netWinning,
    };
};